<template>
    <div v-if="isLoaded">
        <b-card id="card">
            <b-row align-h="end">
                <b-btn @click="exportPDF" style="margin-right: 30px"><i class="fas fa-file-pdf"></i></b-btn>
                <!-- <b-btn v-if="isErasable" variant="danger" @click="deleteItem"><i class="fas fa-trash-alt"></i></b-btn> -->
            </b-row>
            <div id="content">
                <div style="font-weight: bold; margin-top: 10px">{{ $t(name) }}</div>
                <custom-form :isEditable="false" :schema="formSchema" :data="formData" style="margin-top: 30px"/>
                <custom-table :isEditable="false" :initialData="{items: tableData, fields: tableCols}" style="margin-top: 60px; margin-bottom: 60px"/>
            </div>
        </b-card>
    </div>
    <div v-else></div>
</template>

<script>
import CustomForm from '../../../components/CustomForm';
import CustomTable from '../../../components/CustomTable';
import CustomFormTable from '../../../components/CustomFormTable';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default {
    name: 'FormDetail',
    data() {
        return {
            isLoaded: false,
            formSchema: [],
            tableCols: [],
            tableData: [],
            formData: {},
            isErasable: null,
            name: null
        };
    },
    components: {
        CustomTable,
        CustomForm,
        CustomFormTable
    },
    methods: {
        exportPDF() {
            /*
                if we use "content" as element id, pdf and delete button will not be seen if we use
                "card" id, buttons will be seen.
            */
            var w = document.getElementById('content').offsetWidth;
            var h = document.getElementById('content').offsetHeight;
            var site = this.formData.site;
            var no = this.formData.no;
            html2canvas(document.getElementById('content'), {
                dpi: 300,
                scale: 3
            }).then(function(canvas) {
                var img = canvas.toDataURL('image/jpeg', 1);
                var doc = new jsPDF('L', 'pt', [w, h]);
                doc.addImage(img, 'JPEG', 0, 0, w, h);
                doc.save(site + ' - ' + no);
            });
        },
        deleteItem(event) {
            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, () => {
                this.axios
                    .delete(`${this.route.params.site_id}/form/${this.route.params.form_id}`)
                    .then(() => {
                        this.$router.push({
                            name: 'site-forms',
                            params: {site_id: this.route.params.site_id},
                            query: {year: this.year}
                        });
                    })
                    .catch(() => {
                        this.showErrorNotification(
                            'Silme işlemi gerçekleştirilemedi, tekrar deneyin.'
                        );
                    });
            });
        },
        fetchDesign() {
            return this.axios
                .get(`/${this.route.params.site_id}/form/${this.route.params.form_id}`)
                .then(({data}) => {
                    this.formSchema = data.formCols;
                    this.formData = data.formData;
                    if (this.formData.date) {
                        this.formData.date = this.formData.date.split('T')[0];
                    }
                    this.tableCols = data.tableCols;
                    this.tableData = data.tableData;
                    this.name = data.tableName;
                    this.isErasable = data.isErasable;
                    return data;
                });
        },
        init() {
            this.isLoaded = false;
            this.fetchDesign().then(() => {
                this.isLoaded = true;
            });
        }
    },
    created() {
        this.init();
    }
};
</script>

<style scoped>
</style>

<i18n src="../../../i18n/common.json"></i18n>



// WEBPACK FOOTER //
// src/views/Doc/Forms/FormDetail.vue